const mergeURLSearchParams = (...searchParams) => {
  const result = new URLSearchParams('');

  for (const params of searchParams) {
    for (const [key, value] of params.entries()) {
      result.append(key, value);
    }
  }

  return result;
};

export default mergeURLSearchParams;
